// 2024 rules, "Spell Preparation by Class" (D&D Beyond free rules, Spells chapter): classes whose prepared
// spells change when they finish a Long Rest, and how many. Bard, Sorcerer and Warlock change one spell
// when they gain a level instead, so they are not listed. See docs/ranger-level-5-audit.md for the
// other rest-based choices (cantrips, Wild Shape forms, Memorize Spell) still to wire up.
export const REST_SPELL_CHANGES = Object.freeze({
  cleric: Object.freeze({ rest: 'long', count: 'any' }),
  druid: Object.freeze({ rest: 'long', count: 'any' }),
  paladin: Object.freeze({ rest: 'long', count: 1 }),
  ranger: Object.freeze({ rest: 'long', count: 1 }),
  wizard: Object.freeze({ rest: 'long', count: 'any' }),
});

/** Classes the after-rest prompt offers a prepared-spell swap for today (one spell each). */
export const PROMPTED_SPELL_SWAP_CLASSES = Object.freeze(['ranger', 'paladin']);
